import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-all",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListAllComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            }
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
